import { flags } from 'lib/feature-flags/constants'

export const GROUP_EVENT_REGISTRATION_VIEW_EVENT =
  'view-group-event-registration'

export const groupEventRegistrationExperimentProps = ({
  requireContactPhone,
  groupEvent,
} = {}) => ({
  purchase_type: 'group_event',
  experiment_key: flags.FLAG_EXP_GROUP_EVENT_REQUIRE_CONTACT_PHONE,
  contact_phone_required: Boolean(requireContactPhone),
  ...(groupEvent?.slug ? { group_event_slug: groupEvent.slug } : {}),
  ...(groupEvent?.id ? { group_event_id: groupEvent.id } : {}),
})
